import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { DesktopView, MobileView } from '../../../components/responsive-views';

import Accordion from './accordion';
import TabHeader from './tab/header';
import TabContent from './tab/content';

import './styles.scss';

const TabbedContent = ({
  tabs,
}) => {
  const [visibleIndex, setVisibleIndex] = useState([0]);
  const onClick = (newVisibleIndex) => setVisibleIndex([...newVisibleIndex]);

  /**
   * Set the visible index to the correct tab if an anchor hash
   * is supplied.
   */
  useEffect(() => {
    /*
     * If we have multiple open accordions, or if the open tab
     * has been set to anything other than the default 0,
     */
    if (visibleIndex.length > 1 || visibleIndex[0] !== 0) {
      return;
    }

    const { hash } = window.location;
    if (!hash) {
      return;
    }
    tabs.forEach(({ anchor }, index) => {
      if (anchor === hash.slice(1)) {
        setVisibleIndex([index]);
      }
    });
  /*
   * We want to reference `visibleIndex` but we don't want
   * changes to it to cause this effect to run again.
   */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs]);

  return (
    <>
      <DesktopView>
        <div
          className="tab__headers"
          style={{
            'grid-template-columns': `repeat(${tabs.length}, minmax(0, 1fr))`,
          }}
        >
          {
            tabs.map(({
              anchor,
              title,
            }, index) => (
              <TabHeader
                anchor={anchor}
                index={index}
                onClick={onClick}
                title={title}
                visibleIndex={visibleIndex}
              />
            ))
          }
        </div>
        <div>
          {
            tabs.map(({
              content,
            }, index) => (
              <TabContent
                content={content}
                index={index}
                visibleIndex={visibleIndex}
              />
            ))
          }
        </div>
      </DesktopView>
      <MobileView>
        <div>
          {
            tabs.map(({
              anchor,
              content,
              title,
            }, index) => (
              <Accordion
                anchor={anchor}
                content={content}
                index={index}
                onClick={onClick}
                title={title}
                visibleIndex={visibleIndex}
              />
            ))
          }
        </div>
      </MobileView>
    </>
  );
};

TabbedContent.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      anchor: PropTypes.string,
      content: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
};

export default TabbedContent;
